export default class UploadImage {
  // `options.timeoutMs` (optional): abort the upload after this long and
  // answer { error, timedOut: true } instead of waiting on a request that may
  // never finish. Leave it out and nothing changes — every screen written
  // before it keeps the old behaviour exactly (the Choose your Experience
  // editor is the one that asks for it).
  async upload_file(file, options = {}) {
    const formData = new FormData();
    formData.append('file', file);
    console.log(file.type)
    if(file && (file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/gif" || file.type === "image/webp" || file.type === "image/svg+xml")){
      if( file.size > 2200000 ){
        return {error:"File too big: max size is 2 MB"};
      }
    } else if(file && file.type === "video/mp4") {
      if( file.size > 22000000 ) {
        return {error:"File too big: max size is 20 MB"};
      }
    } else {
      return {error: "Wrong file type"};
    }

    const timeoutMs = options && Number.isFinite(options.timeoutMs) && options.timeoutMs > 0 ? options.timeoutMs : 0;
    const controller = timeoutMs && typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timer = controller ? setTimeout(() => controller.abort(), timeoutMs) : null;

    try {
      const response = await fetch('https://nodeimageuploader.herokuapp.com/image_upload', {
        method: 'POST',
        body: formData,
        // headers is removed as fetch will set it properly for formData
        ...(controller ? { signal: controller.signal } : {})
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const text = await response.text()
      console.log(text)

      // Check if there's an error key in the response
      if(text){
        return {imageUrl: text};
      } else {
        return {};
      }
    } catch (error) {
      if (controller && controller.signal.aborted) {
        const seconds = Math.max(1, Math.round(timeoutMs / 1000));
        return {
          error: `The upload took longer than ${seconds} second${seconds === 1 ? '' : 's'}, so it was stopped. Check your connection and try again.`,
          timedOut: true
        };
      }
      return {error: error.message}; // if you want to return the error message
    } finally {
      if (timer) clearTimeout(timer);
    }
  }
}
